import React, { FC } from 'react';
import Head from 'next/head';
import { SWRConfig } from 'swr';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

declare const zonePathGlobal: string;

export type PageContainerProps = {
  Component: any;
  pageProps: any;
};

export const PageContainer: FC<PageContainerProps> = ({ Component, pageProps }) => (
  <SWRConfig
    value={{
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    }}
  >
    <>
      <Head>
        <link rel="icon" href={`${zonePathGlobal}/cp_assets/favicon.ico`} />
      </Head>
      <Box marginTop={20} marginBottom={7}>
        <Container maxWidth="md">
          <Component {...pageProps} />
        </Container>
      </Box>
    </>
  </SWRConfig>
);
